import axios from 'axios';

export default {
  findAdminLegalDocuments: (data) => {
    return axios.put('/api/admin/legal-documents', data)
      .then(response => ({
        legalDocuments: response.data.legalDocuments ?? [],
      }));
  },

  addAdminLegalDocument: (payload) => {
    return axios.post('/api/admin/legal-documents', payload)
      .then(response => ({
        legalDocument: response.data.legalDocument ?? {},
      }));
  },

  getAdminLegalDocument: (payload) => {
    return axios.get(`/api/admin/legal-documents/${payload.entityId}`)
      .then(response => ({
        legalDocument: response.data.legalDocument ?? {},
      }));
  },

  saveAdminLegalDocument: (payload) => {
    return axios.put(`/api/admin/legal-documents/${payload.entityId}`, payload)
      .then(response => ({
        legalDocument: response.data.legalDocument ?? {},
      }));
  },

  deleteAdminLegalDocument: (payload) => {
    return axios.delete(`/api/admin/legal-documents/${payload.entityId}`)
      .then(response => ({
        message: response.data.message ?? '',
      }));
  },
};
